export default __webpack_public_path__ + "static/media/udacity.0d4ac507.svg";